import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { StaticQuery, graphql } from 'gatsby'

const BestofHouzz = () => (
  <StaticQuery
    query={graphql`
      query {
        fileName: file(relativePath: { eq: "houzz-service-award2.jpg" }) {
          childImageSharp {
            gatsbyImageData(width: 370)
          }
        }
      }
    `}
    render={(data) => {
      return null
      return (
        <GatsbyImage
          className="shadow-md border-radius mb-4"
          image={getImage(data.fileName.childImageSharp)}
          alt="Best of Houzz 2020 Service Award"
        />
      )
    }}
  />
)
export default BestofHouzz
